/**
 * Helmet for Artist
 */

import tr from '../../../locales';
import { getResponsiveAssets } from '../../../utils/image';
import { getOriginLocation } from '../../../utils/router';

import { template } from 'lodash';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { twitterHandleFromURL } from '../../../utils/string';

interface IOwnStateProps {
  businessInformation: GQL.IBusinessInformation;
}

interface IOwnProps {
  artist: GQL.IArtist;
  tracks: ArtistTrackForSEO[];
}

export type ArtistTrackForSEO = Pick<GQL.ITrackSearchResult, 'title'>;
type ArtistHelmetProps = IOwnStateProps & IOwnProps;

const defaultList = [];

function ArtistHelmet(props: ArtistHelmetProps) {
  const {
    artist: {
      assets,
      bio,
      name,
      twitter,
    },
    tracks,
  } = props;

  const title = template(tr.pageTitles.artistAndTrackTemplate)({ entity: name! });
  const coverAssets = getResponsiveAssets('cover', assets || defaultList);
  const image = coverAssets.xlarge.find(({ format }) => format !== 'webp');
  const imageHasMetadata = !!image && !!image.metadata;
  const description = bio || template(tr.metaDescriptions.artistDefaultTemplate)({ artist: name });

  return (
    <Helmet titleTemplate={undefined}>
      <title>{title}</title>
      <meta name="description" property="og:description" content={description} />
      <meta property="og:determiner" content="an" />
      <meta property="og:title" content={title} />
      <meta property="og:image" content={`${getOriginLocation()}${image!.path}`} />
      <meta property="og:image:type" content="image/jpeg" />
      {imageHasMetadata && [
        <meta key="og:image:width" property="og:image:width" content={image!.metadata.width.toString()} />,
        <meta key="og:image:width" property="og:image:height" content={image!.metadata.height.toString()} />,
      ]}
      <meta property="og:image:alt" content={`Picture of artist ${name} available on ${tr.pageTitles.default}`} />
      {!!twitter && <meta name="twitter:creator" content={`@${twitterHandleFromURL(twitter) || twitter}`} />}
      <script type="application/ld+json">{`{
        "@context": "http://schema.org",
        "@type": "MusicGroup",
        "name": "${name}",
        "description": "${description}",
        "track": {
          "@type": "ItemList",
          "numberOfItems": ${tracks.length},
          "itemListElement": [
            ${tracks.map((track, index) => `
              {
                "@type": "ListItem",
                "position": ${index + 1},
                "item": {
                  "@type": "MusicRecording",
                  "name": "${track.title}"
                }
              }
            `)}
          ]
        }
      }`}</script>
    </Helmet>
  );
}

const ConnectedArtistHelmet = connect<IOwnStateProps, {}, IOwnProps, IStoreState>(
  ({ staticData }) => ({
    businessInformation: staticData.businessInformation as GQL.IBusinessInformation,
  }),
)(ArtistHelmet);

export default ConnectedArtistHelmet;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Artist/helmet.tsx